export default "/images/CRM.svg?dca04a4dddba75e68b5dc5b4fa2c7216";